<template>
<div>
  <ul>
    <li @click="changeSeason(season.englishName)"
        v-for="season in seasonArr" :key="season.id">
      {{season.name}}-{{season.englishName}}
    </li>
  </ul>
  <div class="season">
    <router-view></router-view>
  </div>
</div>
</template>

<script>
export default {
  name: "ChangeSeason",
  data(){
    return{
      seasonArr:[
        {id:'1',name:"春",englishName:"Spring"},
        {id:'2',name:"夏",englishName:"Summer"},
        {id:'3',name:"秋",englishName:"Autumn"},
        {id:'4',name:"冬",englishName:"Winter"}
      ]
    }
  },
  methods:{
    changeSeason(val){
      this.$router.push({
        name:val
      })
    }
  }
}
</script>

<style scoped lang="scss">
ul{
  display: flex;
  width: 200px;
  justify-content: space-between;
  margin: 0 auto;
  cursor: pointer;

}
</style>